import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetectarDispositivoService {

  constructor() { }

  isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }

  isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

}
